module.exports = __webpack_public_path__ + "img/20200122125602576.59dac72d.jpg";